import TemplateContents from './TemplateContents';
import lottie from "lottie-web/build/player/lottie_svg";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
    this.animations = [];
    this.animationPCLen = 9;
    this.animationSPLen = 15;

    this.animationFilesSP  = [
      'st_1_sp',
      'st_2_sp',
      'st_3-1_sp',
      'st_3-2_sp',
      'st_4-1_sp',
      'st_4-2_sp',
      'st_5-1_sp',
      'st_5-2_sp',
      'st_6-1_sp',
      'st_6-2_sp',
      'st_7-1_sp',
      'st_7-2_sp',
      'st_8-1_sp',
      'st_8-2_sp',
      'st_9-1_sp',
    ];

    this.lottieQueue = [];
    this.isLottiePlaying = false;

    // 特定のLottieは最後まで待たずに次を再生する設定
    this.overlapSettings = {
      'lottie-container5': 0.2, // PCの5番目は70%で次へ
      'lottie-container7_sp': 0.2, // SPの7番目は40%で次へ
    };
  }

  setDom() {
    super.setDom();
  }

  initEvents() {
    super.initEvents();
  }

  start() {
    // スクロール連動用のObserverを作成
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const container = entry.target;
          if (container._lottie) {
            this.lottieQueue.push(container._lottie);
            this.playNextLottie();
          }
          obs.unobserve(container);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 1.0 // 100%表示されたら再生
    });

    const SPEED = 1.9;

    for( let i = 0, len = this.animationPCLen; i < len; i++ ){
      const id = i + 1;
      const container = document.getElementById(`lottie-container${id}`);
      if (container) {
        const animation = lottie.loadAnimation({
          container: container,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: this.pack.ASSETS_PATH + `lottie/pc/st${id}/data.json`
        });
        animation.setSpeed(SPEED);

        let nextTriggered = false;
        let overlapThreshold = this.overlapSettings[container.id];
        if (overlapThreshold === undefined) overlapThreshold = 0.5;

        if (overlapThreshold < 1.0) {
          animation.addEventListener('enterFrame', () => {
            if (!nextTriggered && (animation.currentFrame / animation.totalFrames) >= overlapThreshold) {
              nextTriggered = true;
              this.isLottiePlaying = false;
              this.playNextLottie();
            }
          });
        }

        animation.addEventListener('complete', () => {
          if (!nextTriggered) {
            this.isLottiePlaying = false;
            this.playNextLottie();
          }
        });
        container._lottie = animation; // 要素にインスタンスを紐付け
        observer.observe(container);   // 監視開始
        this.animations.push(animation);
      }
    }

    for( let i = 0, len = this.animationSPLen; i < len; i++ ){
      const id = i + 1;
      const container = document.getElementById(`lottie-container${id}_sp`);
      if (container) {
        const animation = lottie.loadAnimation({
          container: container,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: this.pack.ASSETS_PATH + `lottie/sp/${this.animationFilesSP[i]}/data.json`
        });
        animation.setSpeed(SPEED);

        let nextTriggered = false;
        let overlapThreshold = this.overlapSettings[container.id];
        if (overlapThreshold === undefined) overlapThreshold = 0.5;

        if (overlapThreshold < 1.0) {
          animation.addEventListener('enterFrame', () => {
            if (!nextTriggered && (animation.currentFrame / animation.totalFrames) >= overlapThreshold) {
              nextTriggered = true;
              this.isLottiePlaying = false;
              this.playNextLottie();
            }
          });
        }

        animation.addEventListener('complete', () => {
          if (!nextTriggered) {
            this.isLottiePlaying = false;
            this.playNextLottie();
          }
        });
        container._lottie = animation;
        observer.observe(container);
        this.animations.push(animation);
      }
    }
  }

  playNextLottie() {
    if (this.isLottiePlaying) return;
    if (this.lottieQueue.length === 0) return;

    const animation = this.lottieQueue.shift();
    if (animation) {
      this.isLottiePlaying = true;
      animation.play();
    }
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
